import React from "react";
import styled from "styled-components";
import { Icon, Center } from "components/common";
import styles from "./MessageWidgets.css";
const Description = styled.div`
  max-width: 700px;
`;
const ErrorList = styled.ul`
  padding: 0;
`;
const Row = styled.div`
  margin-bottom: 5px;

  &:last-child {
    margin-bottom: 0;
  }
`;
const ErrorWidget = ({
  errors,
  title = "While retrieving data for this widget, the following error(s) occurred:"
}) => /* @__PURE__ */ React.createElement(Center, null, /* @__PURE__ */ React.createElement(Icon, { name: "warning", size: "3x", className: styles.iconMargin }), /* @__PURE__ */ React.createElement(Description, null, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement("strong", null, title)), /* @__PURE__ */ React.createElement(ErrorList, null, errors.map((e) => /* @__PURE__ */ React.createElement(Row, { as: "li", key: e.description }, e.description)))));
export default ErrorWidget;
